// Sand particle fragment — warm golden-sandy granules

varying float vAlpha;
varying float vRandom;

void main() {
    vec2  uv   = gl_PointCoord - vec2(0.5);
    float dist = length(uv) * 2.0;

    float alpha = 1.0 - smoothstep(0.4, 1.0, dist);

    // Sandy colour variation per particle (dark amber → warm gold)
    vec3 sandDark  = vec3(0.65, 0.48, 0.20);
    vec3 sandLight = vec3(0.88, 0.72, 0.38);
    vec3 col       = mix(sandDark, sandLight, vRandom);

    gl_FragColor = vec4(col, alpha * vAlpha * 0.90);

    #include <colorspace_fragment>
}
